var exports = {
  "kL": "x4ddf2309--51895a--container",
  "p_": "x4ddf2309--51895a--list",
  "x3": "x4ddf2309--51895a--list-item",
  "l3": "x4ddf2309--51895a--list-item--active",
  "yc": "x4ddf2309--51895a--list-item_link",
};

module.exports = exports;
